import actions from './actions';
import mutations from './mutations';

const state = {
  activatedCEModules: []
};

const getters = {
  // eslint-disable-next-line no-shadow
  items: (state) => state.activatedCEModules,
  // eslint-disable-next-line no-shadow
  getActivatedCEModule: (state) => (id) => state.activatedCEModules.find((m) => m.id === id)
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
